import React, { createContext, useState, useContext, useEffect } from 'react';
import { GetPassPolicies } from "../services/pass-service";
import { PassPolicy } from 'models/IPassPolicy';
import { useUserContext } from './user';

interface PassPoliciesContextProps {
    passPolicies: PassPolicy[];
    setPassPolicies: React.Dispatch<React.SetStateAction<any[]>>;
}

const PassPoliciesContext = createContext<PassPoliciesContextProps | undefined>(undefined);

export const PassPoliciesProvider: React.FC<{ children: React.ReactElement }> = ({ children }) => {
    const [passPolicies, setPassPolicies] = useState<PassPolicy[]>([]);
    const userInfo = useUserContext();

    useEffect(() => {
        const sponsorId = userInfo?.passplayUser?.sponsorId;
        if (sponsorId) {
            GetPassPolicies(sponsorId).then((policies) => {
                setPassPolicies(policies.data || []);
            });
        }
    }, [userInfo?.passplayUser]);

    return (
        <PassPoliciesContext.Provider value={{ passPolicies, setPassPolicies }}>
            {children}
        </PassPoliciesContext.Provider>
    );
};

export const usePassPolicies = () => {
    const context = useContext(PassPoliciesContext);
    if (context === undefined) {
        throw new Error('usePassPolicies must be used within a PassPoliciesProvider');
    }
    return context;
};